import React from "react";
import { motion } from "framer-motion";
import Loader from "../../CircularLoader/CircularLoader";

const BoltButton = ({
  icon: Icon,
  label,
  badge,
  onClick,
  className = "",
  iconClassName = "",
  labelClassName = "",
  badgeClassName = "",
  disabled = false,
  variant = "primary",
  size = "default",
  hoverAnimation = true,
  iconSize,
  render,
  loading = false,
  ...props
}) => {
  // Mirrors the reference design's three button styles: .bp / .bg / .bdr
  const variantStyles = {
    primary: "bg-brand text-white border-brand hover:bg-brand-hover",
    outline:
      "bg-ui-surface text-ui-text-muted border-ui-border hover:bg-brand-light hover:border-brand hover:text-brand",
    light:
      "bg-ui-surface-sunken text-ui-text-muted border-ui-border hover:bg-brand-light hover:border-brand hover:text-brand",
    danger:
      "bg-ui-surface text-state-danger-text border-state-danger-border hover:bg-state-danger-bg",
    success: "bg-state-success text-white border-state-success hover:opacity-90",
  };

  const badgeVariantStyles = {
    primary: "bg-ui-surface text-brand",
    outline: "bg-brand text-white",
    light: "bg-brand text-white",
    danger: "bg-state-danger-bg text-state-danger-text",
    success: "bg-ui-surface text-state-success-text",
  };

  const isFilled = variant === "primary" || variant === "success";

  const sizeStyles = {
    default: "px-[2px] sm:px-1.5 py-1 sm:py-1.5 text-[9px] 3xl:text-xs",
    sm: "px-2 py-1 text-xs",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  const iconSizeMap = {
    default: "w-4 h-4",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  return (
    <motion.button
      disabled={disabled}
      onClick={onClick}
      className={`
        flex items-center justify-center gap-2 px-2 min-h-[30px] min-w-fit rounded-lg border transition-all duration-200
        ${variantStyles[variant] || variantStyles.primary}
        ${sizeStyles[size] || sizeStyles.default}
        ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
        ${className}
      `}
      {...props}
    >
      {render ? (
        render()
      ) : (
        <>
          {Icon && (
            <Icon
              size={iconSize}
              className={`
                ${!iconSize ? iconSizeMap[size] || iconSizeMap.default : ""}
                ${isFilled ? "text-white" : "text-current"}
                ${iconClassName}
              `}
            />
          )}
          {loading ? (
            <Loader />
          ) : (
            label && (
              <span
                className={`
                  font-medium text-[11px] 3xl:text-xs 4xl:text-sm
                  ${isFilled ? "text-white" : "text-current"}
                  ${labelClassName}
                `}
              >
                {label}
              </span>
            )
          )}
          {badge !== undefined && badge !== null && (
            <span
              className={`
                inline-flex items-center justify-center min-w-[20px] h-4 px-1.5 
                rounded-full text-[10px] 3xl:text-xs 4xl:text-sm font-bold
                ${badgeVariantStyles[variant] || badgeVariantStyles.primary}
                ${badgeClassName}
              `}
            >
              {badge}
            </span>
          )}
        </>
      )}
    </motion.button>
  );
};

export default BoltButton;
